module.exports = __webpack_public_path__ + "static/img/brasao-cor-horizontal.0effeb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/img/brasao-cor-horizontal.png
// module id = VhyD
// module chunks = 15